export const isTeamWinner = (team, allTeamsInMatch) => {
    if (!team.isWinner) return false;

    // Если только одна команда в матче, она победитель
    if (!allTeamsInMatch || allTeamsInMatch.length <= 1) return true;

    // Проверяем, что счет этой команды больше или равен другим
    const otherTeams = allTeamsInMatch.filter(t => t.id !== team.id);
    const teamScore = team.score || 0;

    return otherTeams.every(otherTeam => {
        const otherScore = otherTeam.score || 0;
        return teamScore >= otherScore;
    });
};
